import React, { memo, useCallback } from "react"

import { useApp } from "../../../hooks/useApp"

export const withSearchWidget = Component =>
  memo(({ name = "SearchWidget", location, activeHeaderHero }: any) => {
    const { globalStateReducer } = useApp()

    const [{ activeSearch, activeCart, activeMenu }, dispatch] = globalStateReducer

    const handleClick = useCallback(() => {
      dispatch({
        type: "setActiveSearch",
        payload: !activeSearch,
      })
    }, [dispatch, activeSearch])

    Component.displayName = name
    return (
      <Component
        handleClick={handleClick}
        activeSearch={activeSearch}
        activeCart={activeCart}
        activeMenu={activeMenu}
        activeHeaderHero={activeHeaderHero}
        location={location}
      />
    )
  })
